export default function KpiCard({ title, value, subtitle }) {
  return (
    <div className="card shadow-sm h-100">
      <div className="card-body">
        <div className="text-muted small">{title}</div>
        <div className="fs-3 fw-bold">{value}</div>
        {subtitle ? <div className="text-muted small">{subtitle}</div> : null}
      </div>
    </div>
  );
}